import { getReceipt } from "../services/Rest.jsx";
import useFetch from "./useFetch.jsx";

const useReceipt = (receiptId, autoFetch = true) => {
  return useFetch(getReceipt, autoFetch, receiptId);
};

export default useReceipt;
